import React, { useContext } from 'react';

import { Collapse, List, ListItem, Paper, ListItemText } from '@material-ui/core';
import { ExpandLessRounded, ExpandMoreRounded } from '@material-ui/icons';
import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../../store';
import { initialEventTemplate } from '../../../../../store/admin/events/store';

import { useBoolean } from '../../../../common/Hooks/useBoolean.hook';
import { EventWizardNavigatorMobileRoundItem } from './EventWizardNavigatorMobileRoundItem';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';

export const EventWizardNavigatorMobile = () => {
  const {
    adminEvents,
    notifications: { open: openNotificationSnackbar }
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const [mobileNavigatorOpen, , toggleMobileNavigatorOpen] = useBoolean(false);

  const [openEventSetup, setOpenEventSetup, toggleOpenEventSetup] = useBoolean(false);
  const [openCompleteEvent, setOpenCompleteEvent, toggleOpenCompleteEvent] = useBoolean(false);

  const event = adminEvents[Number(eventId)] || initialEventTemplate;

  const baseWizard = `/staff/club/${clubId}/event/${eventId}`;
  const baseEventSection = `${baseWizard}/setup`;
  const baseCompleteEventSection = `${baseWizard}/complete`;

  const navigateTo = (destinationURL: string) => () => {
    navigate(destinationURL);
    setOpenEventSetup(false);
    setOpenCompleteEvent(false);
    toggleMobileNavigatorOpen();
  };

  const subitemsMetadata = {
    completeEvent: [
      { section: `${baseCompleteEventSection}`, label: 'Results' },
      { section: `${baseCompleteEventSection}`, label: 'Complete Event' }
    ],
    eventSetup: [
      { section: `${baseEventSection}/start`, label: 'Getting started' },
      { section: `${baseEventSection}/basic`, label: 'Event Basics' },
      { section: `${baseEventSection}/formats`, label: 'Formats' },
      { section: `${baseEventSection}/rounds`, label: 'Round Details' },
      // Temporarily disable fees screen due to https://code.talpor.com/club15/frontend/-/issues/900
      // { section: `${baseEventSection}/fees`, label: 'Entry Fees' },
      { section: `${baseEventSection}/publish`, label: 'Publish Events' },
      { section: `${baseEventSection}/players`, label: 'Invite Players' }
    ]
  };

  return (
    <div className="event-wizard-navigator-mobile">
      {!openNotificationSnackbar && (
        <div className="mobile-menu-switch" onClick={toggleMobileNavigatorOpen}>
          {mobileNavigatorOpen ? <ExpandLessRounded /> : <ExpandMoreRounded />}
        </div>
      )}

      <Collapse in={mobileNavigatorOpen} className="mobile-menu">
        <Paper elevation={4}>
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className="nested-list-subheader"
          >
            <ListItem button={true} className={'mobile-menu-item'} onClick={toggleOpenEventSetup}>
              {openEventSetup ? <ExpandLessRounded /> : <ExpandMoreRounded />}
              <ListItemText primary="Event setup" />
            </ListItem>
            <Collapse in={openEventSetup} timeout="auto" unmountOnExit={true}>
              <List disablePadding={true} className={'mobile-menu-sublist'}>
                {subitemsMetadata.eventSetup.map(subitem => (
                  <ListItem
                    button={true}
                    className="mobile-menu-subitem"
                    onClick={navigateTo(`${subitem.section}`)}
                    key={`subitem-eventSetup-${subitem.label}`}
                  >
                    <ListItemText className="mobile-menu-subitem-label" primary={subitem.label} />
                  </ListItem>
                ))}
              </List>
            </Collapse>

            {(event.rounds && event.status === 'published' ? event.rounds : []).map(
              (round, index) => (
                <EventWizardNavigatorMobileRoundItem
                  key={`round--item-${index}`}
                  index={index}
                  round={round}
                  clubId={Number(clubId)}
                  eventId={Number(eventId)}
                  navigateTo={navigateTo}
                />
              )
            )}

            <ListItem
              button={true}
              className={'mobile-menu-item'}
              onClick={toggleOpenCompleteEvent}
            >
              {openCompleteEvent ? <ExpandLessRounded /> : <ExpandMoreRounded />}
              <ListItemText primary="Complete Event" />
            </ListItem>
            <Collapse in={openCompleteEvent} timeout="auto" unmountOnExit={true}>
              <List disablePadding={true} className={'mobile-menu-sublist'}>
                {subitemsMetadata.completeEvent.map(subitem => (
                  <ListItem
                    button={true}
                    className="mobile-menu-subitem"
                    onClick={navigateTo(`${subitem.section}`)}
                    key={`subitem-eventSetup-${subitem.label}`}
                  >
                    <ListItemText className="mobile-menu-subitem-label" primary={subitem.label} />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </List>
        </Paper>
      </Collapse>
    </div>
  );
};
